import React, { Component, useEffect, useState } from 'react';
import { connect } from 'react-redux';
import moment from 'moment';
import { FormattedMessage, injectIntl } from 'react-intl';
import {
	Row,
	Col,
	Button,
	Container
} from 'react-bootstrap';
import cx from 'classnames';
import withStyles from 'isomorphic-style-loader/withStyles';
import { FaCheck, FaFile, FaFileAlt, FaMotorcycle, FaUser } from 'react-icons/fa';

import s from './Orders.css';
import rs from '../../../storeCommon.css';

//Images
import viewIcon from '../../../../../public/StoreIcon/view-icon.svg';

import messages from '../../../../locale/messages';
import { bookingStatusLocale } from '../../../../helpers/bookingStatusLocale';

import updateOrderStatus from '../../../../actions/shop/orders/updateOrderStatus';
import updateItemStatus from '../../../../actions/shop/orders/updateItemStatus';
import approveAndSearchDriver from '../../../../actions/shop/orders/approveAndSearchDriver';
import { openDeclineReasonModal, openModal, closeModal } from '../../../../actions/siteadmin/modalActions';

import DeclineReasonModal from '../DeclineReasonModal';
import Link from '../../../Link';
import ConfirmationPopup from '../../../Common/ConfirmationPopup/ConfirmationPopup';
import OrderItemThumbnail from '../../../Common/OrderItemThumbnail';
import { formatIDR } from '../../../../utils/formatIDR';
import { FaTruck, FaXmark } from 'react-icons/fa6';
import SvgSpinners6DotsScale from '../../../Common/Loader/SearchDriverLoader';

class Orders extends Component {
	static defaultProps = {
		showDeclineModal: false
	};

	constructor(props) {
		super(props);
		this.state = {
			socketReceivers: [
				'orderReceived', 'shopApproved', 'shopDeclined', 'shopExpired', 'deliveryNotFound', 'testRequest',
				'deliveryAccept', 'cancelDelivery', 'confirmDelivery', 'startDelivery', 'completeDelivery', 'unableToDelivery'],
			buttonLoader: {}
		};

		this.renderBookingStatus = this.renderBookingStatus.bind(this);
		this.handleSocketResponse = this.handleSocketResponse.bind(this);
		this.handleDeliveryStatus = this.handleDeliveryStatus.bind(this);
		this.handleButtonLoader = this.handleButtonLoader.bind(this);
		this.confirmModalBody = this.confirmModalBody.bind(this);
	}

	componentDidMount() {
		const { userId, type, currentPage, data, data: { refetch }, socket } = this.props;
		const { socketReceivers } = this.state;
		let page = type === 'upcoming' ? 1 : currentPage;
		let that = this;

		if (socket && data && data.refetch && userId) {
			socketReceivers.map((item) => {
				if (`${item}-${userId}` === `testRequest-${userId}`) {
					socket.on(`${item}-${userId}`, (data) => {
						console.log(`${item}-${userId}`, data);
					});
				} else {
					socket.on(`${item}-${userId}`, (data) => { that.handleSocketResponse(page); });
				}
			});
		}
	}

	componentWillUnmount() {
		const { socket, userId } = this.props;
		const { socketReceivers } = this.state;

		try {
			if (socket && socketReceivers) {
				socketReceivers.map((item) => {
					socket.removeListener(`${item}-${userId}`);
				});
			}
			clearTimeout(this.buttonLoaderTimeout);
		} catch (error) {
		}
	}

	handleButtonLoader(id) {
		const { buttonLoader } = this.state;
		let updatedButtonLoader = buttonLoader;

		updatedButtonLoader[id] = true;
		this.setState({ buttonLoader: updatedButtonLoader });
		this.buttonLoaderTimeout = setTimeout(() => {
			updatedButtonLoader[id] = false;
			this.setState({ buttonLoader: updatedButtonLoader });
		}, 1000);
	}

	confirmModalBody(code) {
		const { formatMessage } = this.props.intl;
		return (
			code &&
			<>
				<h4 className={cx(s.completeText, 'textRightRTL')}>
					<FormattedMessage {...messages.orderConfirmation} />
				</h4>
				<h5 className={cx(s.confirmCode, 'textRightRTL')} >
					{`${formatMessage(messages.confirmationCode)}: ${code}`}
				</h5>
			</>
		)
	}

	handleSocketResponse(page) {
		const { paginationData } = this.props;
		paginationData(page);
	}

	async handleDeliveryStatus(id, status) {
		const { updateItemStatus, paginationData, closeModal } = this.props;
		this.handleButtonLoader(id);
		await updateItemStatus(id, null, status);
		await paginationData(1); // refech data
	}

	async handleAcceptOrder(id) {
		const { approveAndSearchDriver, paginationData } = this.props;
		await approveAndSearchDriver(id);
		await paginationData(1); // refech data
	}

	async handleStatusChange(id, orderItemDetails, e) {
		const { updateOrderStatus, openDeclineReasonModal, currentPage, paginationData } = this.props;
		const bookingStatus = e.target.value;

		this.handleButtonLoader(id);

		if (bookingStatus === 'approved') {
			await updateOrderStatus(id, bookingStatus, currentPage);
			await paginationData(1); // refech data
		} else if (bookingStatus === 'declined') {
			await openDeclineReasonModal(id, currentPage, orderItemDetails);
		}
	}

	renderBookingStatus(status, isDoorStepDelivery, deliveryPartnerDetails) {
		const { currentLocale } = this.props;
		const { formatMessage } = this.props.intl;
		let statusColor = '';
		let statusText = '';
		switch (status) {
			case 'completed':
				statusColor = 'success';
				statusText = 'completed';
				break;
			case 'declined':
				statusColor = 'danger';
				statusText = 'declined';
				break;
			case 'pending':
				statusColor = 'warning';
				statusText = 'pending';
				break;
			case 'approved':
			case 'readyForDelivery':
				statusColor = 'info';
				if (isDoorStepDelivery && !deliveryPartnerDetails) {
					statusText = 'readyForDelivery';
				} else if (isDoorStepDelivery && deliveryPartnerDetails !== null) {
					statusText = 'driverFound';
				}
				else {
					statusText = 'readyForPickup';
				}
				break;

			default:
				statusColor = 'secondary';
				statusText = status;
		}

		return <div className={cx('badge', `badge-${statusColor}`)}>
			<span className='pr-1'>{bookingStatusLocale(statusText, currentLocale)}</span>
			{statusText === 'readyForDelivery' && <SvgSpinners6DotsScale />
			}
		</div>
	}
	render() {
		const { formatMessage } = this.props.intl;
		const { data, data: { loading, getAllOrders, refetch }, type, showDeclineModal, currentLocale, openModal, closeModal, completeConfirmModal, modalData } = this.props;
		const { buttonLoader } = this.state;
		let allowedItemStatus = ['approved'];

		return (
			<>
				{
					type === 'upcoming' && showDeclineModal === true && <DeclineReasonModal refetch={refetch} />
				}
				<div className={s.container}>

					<ConfirmationPopup
						modalStatus={completeConfirmModal}
						title={formatMessage(messages.orderComplete)}
						body={this.confirmModalBody(modalData?.confirmCode)}
						closeModal={() => closeModal('completeConfirmModal')}
						popupButtonLeftName={formatMessage(messages.cancelButton)}
						popupButtonRightName={formatMessage(messages.confirmButton)}
						popupButtonLeftFunction={() => closeModal('completeConfirmModal')}
						popupButtonRightFunction={() => this.handleDeliveryStatus(modalData?.id, modalData?.status)}
						orderTitle={cx(s.orderTitleText, 'textAlignRightRTL')}
					/>

					<Container className='px-0'>
						<Row>
							<Col md={6} lg={6} sm={12} xs={12} className='mx-auto'>
								<div className={s.panelBody}>
									<div className={cx('orderCardGrid')}>
										{getAllOrders.results && getAllOrders.results.length > 0 ? (

											getAllOrders.results.map((booking, key) => {
												return (
													<div key={booking.id} className='bg-white my-4'>
														<div className='d-flex justify-content-between align-items-center p-3 border-bottom border-bottom-dashed'>
															<div>
																{this.renderBookingStatus(booking.bookingStatus, booking.isDoorStepDelivery)}
																<div className='small'>{moment(new Date(booking.bookingCreatedAt).toISOString()).fromNow()}</div>
															</div>
															<div>
																<div className='small'>Order ID</div>
																<div className=''>#{booking.orderId}</div>
																{/* {booking.isDoorStepDelivery ? <FaMotorcycle /> : <FaUser />} */}
															</div>
														</div>
														{/* <div className='bg-info text-white small text-center'>Self Pickup</div> */}
														<div className="p-3">
															{/* <div className="d-flex justify-content-between align-items-center mb-2">
																<div className="small text-muted">{booking.userName}</div>
															</div> */}
															<div className="mb-2 d-flex justify-content-between">
																<span className="font-weight-bold">Total: {booking.orderItemsCount} items</span>
															</div>
															<div>
																{booking.orderItemDetails && booking.orderItemDetails.map((item) => (
																	<>
																		<div className='mb-1 p-1 bg-light d-flex align-items-start' key={item.id}>
																			<OrderItemThumbnail image={item.image} name={item.itemName} />
																			<div className='flex-grow-1'>
																				<div>{item.itemName}</div>
																				<div style={{ display: 'flex', justifyContent: 'space-between', flexDirection: 'column' }}>
																					<span style={item.totalWithDiscount ? { textDecoration: 'line-through', color: '#888', fontStyle: 'italic', fontSize: '12px' } : {}} className='text-muted small'>{item.quantity} &times; {formatIDR(item.total)}</span>
																					{item.totalWithDiscount && <span className='text-muted small'>{item.quantity} &times; {formatIDR(item.totalWithDiscount)}</span>}
																				</div>
	
																				{/* Render Modifier if item has modifier */}
																				{(item.orderModifierGroup && item.orderModifierGroup.length > 0) &&
																					<div className='ml-3 small'>
																						{
																							item.orderModifierGroup.map((modifier, index) => (
																								<div key={index} className='text-info'>
																									{modifier.modifierName}
																									<div>
																										{modifier.orderModifierItem.map((extraItem, extraItemIndex) => (
																											<div key={extraItemIndex} className='ml-3 text-dark'>
																												{extraItem.modifierItemName}{' '}
																												(
																												{extraItem.quantity}&times;
																												{formatIDR(extraItem.total)}
																												)
																											</div>
																										))}
																									</div>
																								</div>
																							))
																						}
																					</div>
																				}
																			</div>
																		</div>
																	</>
																))}
															</div>

															<div className='mt-2'>
																Subtotal: <span className='font-weight-bold'>{formatIDR(booking.subTotal)}</span>
															</div>
															{
																booking && booking.packagingFee > 0 && <div className='mt-2'>
																	Packaging Fee: <span className='font-weight-bold'>{formatIDR(booking.packagingFee)}</span>
																</div>
															}
															<div className='mt-2'>
																Total: <span className='font-weight-bold'>{formatIDR(booking.subTotal + (booking && booking.packagingFee || 0))}</span>
															</div>

															{booking.orderNotes &&
																<div className='mt-2 p-1 alert alert-info'>
																	<div className='small'>
																		<FaFileAlt />
																		{' '}
																		<FormattedMessage {...messages.orderNotes} />
																	</div>
																	<div className='font-italic'>
																		{booking.orderNotes}
																	</div>
																</div>
															}


															<div className='mt-4'>
																<Link to={`/store/order-details/${type}/${booking.id}`} className='btn btn-outline-secondary w-100'>
																	<span><FormattedMessage {...messages.viewDetail} /></span>
																</Link>
															</div>

															{/* Accept & Reject action button */}
															{booking.bookingStatus === 'pending' &&
																<div className='mt-4 btn-group w-100'>
																	<Button
																		variant='outline-danger'
																		value={'declined'}
																		disabled={this.state.buttonLoader[booking.id]}
																		onClick={(e) => this.handleStatusChange(booking.id, booking.orderItemDetails, e)}>
																		<FaXmark />{' '}
																		{formatMessage(messages.rejectedLabel)}
																	</Button>
																	<Button
																		variant='success'
																		value={'approved'}
																		disabled={this.state.buttonLoader[booking.id]}
																		onClick={() => this.handleAcceptOrder(booking.id)}>
																		<FaCheck />{' '}
																		{formatMessage(messages.acceptedLabel)}
																	</Button>
																</div>
															}

															{/* Ready for pickup action button */}
															{
																(booking.bookingStatus === 'approved') &&

																<div className='mt-4 alert alert-secondary'>
																	<div>
																		<FaTruck /> SELF PICKUP
																	</div>

																	<p>Siap Untuk Diambil</p>

																	<Button variant='success' className='w-100'
																		disabled={(allowedItemStatus.indexOf(booking.bookingStatus) == -1 ? true : false) || (buttonLoader && buttonLoader[booking.id])}
																		onClick={() => this.handleDeliveryStatus(booking.id, 'readyForDelivery')}>
																		<span className={'vtrSub'}>{bookingStatusLocale('readyForPickup', currentLocale)}</span>
																	</Button>
																</div>
															}

															{/* Delivery done for self pickup */}
															{
																(booking.bookingStatus === 'readyForDelivery' && !booking.isDoorStepDelivery) &&
																<div className='mt-4 alert alert-secondary'>
																	<div>
																		<FaUser /> Self Pickup
																	</div>

																	<p>Waiting for customer to pickup order...</p>

																	<Button variant='success' className='w-100'
																		disabled={buttonLoader && buttonLoader[booking.id]}
																		onClick={() => openModal('completeConfirmModal', { id: booking.id, confirmCode: booking.confirmationCode, status: 'completed' })}>
																		<FormattedMessage {...messages.deliveryDone} />
																	</Button>
																</div>
															}
														</div>
													</div>
												);
											})
										) : (
											<div className={s.alignCenter} style={{ padding: '2rem' }}>
												<FormattedMessage {...messages.noOrdersFoundLabel} />
											</div>
										)}
									</div>
								</div>
							</Col>
						</Row>
					</Container>
				</div>
			</>
		);
	}
};

const mapDispatch = {
	updateOrderStatus,
	updateItemStatus,
	openDeclineReasonModal,
	openModal,
	closeModal,
	approveAndSearchDriver
};
const mapState = (state) => ({
	userId: state.account && state.account.data && state.account.data.id,
	completeConfirmModal: state.modalStatus.completeConfirmModal,
	currentLocale: state.intl.locale,
	modalData: state.modalStatus.data && state.modalStatus.data[0],
});

export default injectIntl(withStyles(s, rs)(connect(mapState, mapDispatch)(Orders)));
